import { KYCServices } from "./services";
import { KYCConstants } from "./constants";
import { SESSIONS_STORAGE_ITEMS } from "../../../Config";
import { requestJSON } from "../..";

export const KYCActions = {
  sendKYCApplication,
  getListKYC,
  modifyKYCApplication,
  approveKYCApplication,
  deleteKYCApplication,
  clearKYCApplication,
  startKYC,
  uploadPowerOfAttorney,
  uploadOrganizationalChart,
  uploadArticlesOfAssociation,
  uploadBeneficiaryDocuments,
  uploadWolfsbergQuestionnaire,
  submitApplication,
  startApplicationSigning,
  checkSigningSca,
  cancelSigning,
  continueApplication,
  checkState,
  startAgreementSigning,
  uploadAdditionalDocuments,
  startOndatoBeneficiaryIdentification,
  uploadApplicationDocument,
  startApplicationSignedUpload,
  uploadSignedApplication,
  cancelUploadDocument,
  uploadSignedAgreement,
  renderPdfFromHtml,
  uploadKycPdf,
  getCalculatedInstitution,
  getCompanyClassification,
};

function cancelUploadDocument() {
  return dispatch => {
    dispatch(request());

    return KYCServices.cancelUploadDocument().then(
      data => dispatch(success(data)),
      error => {
        dispatch(failure(error));
        throw error;
      }
    );
  };

  function request() {
    return { type: KYCConstants.CANCEL_UPLOAD_DOCUMENT_REQUEST };
  }

  function success(data) {
    return { type: KYCConstants.CANCEL_UPLOAD_DOCUMENT_SUCCESS, payload: data };
  }

  function failure(error) {
    return { type: KYCConstants.CANCEL_UPLOAD_DOCUMENT_ERROR, error };
  }
}

function sendKYCApplication(data) {
  return dispatch => {
    dispatch(request());

    return KYCServices.sendKYCApplication(data).then(
      data => dispatch(success(data)),
      error => dispatch(failure(error))
    );
  };

  function request() {
    return { type: KYCConstants.POST_SEND_KYC_APPLICATION_REQUEST };
  }

  function success(data) {
    return { type: KYCConstants.POST_SEND_KYC_APPLICATION_SUCCESS, payload: data };
  }

  function failure(error) {
    return { type: KYCConstants.POST_SEND_KYC_APPLICATION_ERROR, error };
  }
}

function getListKYC(data) {
  return dispatch => {
    dispatch(request());

    return KYCServices.getListKYC(data).then(
      data => dispatch(success(data)),
      error => dispatch(failure(error))
    );
  };

  function request() {
    return { type: KYCConstants.POST_GET_LIST_KYC_REQUEST };
  }

  function success(data) {
    return { type: KYCConstants.POST_GET_LIST_KYC_SUCCESS, payload: data };
  }

  function failure(error) {
    return { type: KYCConstants.POST_GET_LIST_KYC_ERROR, error };
  }
}

function modifyKYCApplication(data) {
  return dispatch => {
    dispatch(request());

    return KYCServices.modifyKYCApplication(data).then(
      data => dispatch(success(data)),
      error => dispatch(failure(error))
    );
  };

  function request() {
    return { type: KYCConstants.POST_MODIFY_KYC_APPLICATION_REQUEST };
  }

  function success(data) {
    return { type: KYCConstants.POST_MODIFY_KYC_APPLICATION_SUCCESS, payload: data };
  }

  function failure(error) {
    return { type: KYCConstants.POST_MODIFY_KYC_APPLICATION_ERROR, error };
  }
}

function approveKYCApplication(kycId) {
  return dispatch => {
    dispatch(request());

    return KYCServices.approveKYCApplication(kycId).then(
      data => dispatch(success(data)),
      error => dispatch(failure(error))
    );
  };

  function request() {
    return { type: KYCConstants.POST_APPROVE_KYC_APPLICATION_REQUEST };
  }

  function success(data) {
    return { type: KYCConstants.POST_APPROVE_KYC_APPLICATION_SUCCESS, payload: data };
  }

  function failure(error) {
    return { type: KYCConstants.POST_APPROVE_KYC_APPLICATION_ERROR, error };
  }
}

function deleteKYCApplication(kycId) {
  return dispatch => {
    dispatch(request());

    return KYCServices.deleteKYCApplication(kycId).then(
      data => dispatch(success(data)),
      error => dispatch(failure(error))
    );
  };

  function request() {
    return { type: KYCConstants.POST_DELETE_KYC_APPLICATION_REQUEST };
  }

  function success(data) {
    return { type: KYCConstants.POST_DELETE_KYC_APPLICATION_SUCCESS, payload: data };
  }

  function failure(error) {
    return { type: KYCConstants.POST_DELETE_KYC_APPLICATION_ERROR, error };
  }
}

function clearKYCApplication() {
  return dispatch => {
    dispatch({ type: KYCConstants.CLEAR_KYC_APPLICATION });
  };
}

function startKYC() {
  return dispatch => {
    const token = JSON.parse(sessionStorage.getItem(SESSIONS_STORAGE_ITEMS.USER))?.token;
    requestJSON.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    dispatch(request());
    return KYCServices.startKYC().then(
      data => dispatch(success(data)),
      error => {
        dispatch(failure(error));
        throw error;
      }
    );
  };

  function request() {
    return { type: KYCConstants.START_KYC_APPLICATION_REQUEST };
  }

  function success(data) {
    return { type: KYCConstants.START_KYC_APPLICATION_SUCCESS, payload: data };
  }

  function failure(error) {
    return { type: KYCConstants.START_KYC_APPLICATION_ERROR, error };
  }
}

function uploadPowerOfAttorney(data) {
  return dispatch => {
    dispatch(request());

    return KYCServices.uploadPowerOfAttorney(data).then(
      data => dispatch(success(data)),
      error => dispatch(failure(error))
    );
  };

  function request() {
    return { type: KYCConstants.UPLOAD_POWER_OF_ATTORNEY_REQUEST };
  }

  function success(data) {
    return { type: KYCConstants.UPLOAD_POWER_OF_ATTORNEY_SUCCESS, payload: data };
  }

  function failure(error) {
    return { type: KYCConstants.UPLOAD_POWER_OF_ATTORNEY_ERROR, error };
  }
}

function uploadOrganizationalChart(data) {
  return dispatch => {
    dispatch(request());

    return KYCServices.uploadOrganizationalChart(data).then(
      data => dispatch(success(data)),
      error => dispatch(failure(error))
    );
  };

  function request() {
    return { type: KYCConstants.UPLOAD_ORGANIZATIONAL_CHART_REQUEST };
  }

  function success(data) {
    return { type: KYCConstants.UPLOAD_ORGANIZATIONAL_CHART_SUCCESS, payload: data };
  }

  function failure(error) {
    return { type: KYCConstants.UPLOAD_ORGANIZATIONAL_CHART_ERROR, error };
  }
}

function uploadSignedApplication(data, documentId) {
  return dispatch => {
    dispatch(request());

    return KYCServices.uploadSignedApplication(data, documentId).then(
      data => dispatch(success(data)),
      error => dispatch(failure(error))
    );
  };

  function request() {
    return { type: KYCConstants.UPLOAD_SIGNED_APPLICATION_REQUEST };
  }

  function success(data) {
    return { type: KYCConstants.UPLOAD_SIGNED_APPLICATION_SUCCESS, payload: data };
  }

  function failure(error) {
    return { type: KYCConstants.UPLOAD_SIGNED_APPLICATION_ERROR, error };
  }
}

function uploadApplicationDocument(data, documentId) {
  return dispatch => {
    dispatch(request());

    return KYCServices.uploadApplicationDocument(data, documentId).then(
      data => dispatch(success(data)),
      error => dispatch(failure(error))
    );
  };

  function request() {
    return { type: KYCConstants.UPLOAD_APPLICATION_DOCUMENT_REQUEST };
  }

  function success(data) {
    return { type: KYCConstants.UPLOAD_APPLICATION_DOCUMENT_SUCCESS, payload: data };
  }

  function failure(error) {
    return { type: KYCConstants.UPLOAD_APPLICATION_DOCUMENT_ERROR, error };
  }
}

function getCalculatedInstitution(legalForm, nace) {
  return dispatch => {
    dispatch(request());

    return KYCServices.getInstitution(legalForm, nace).then(
      data => dispatch(success(data)),
      error => dispatch(failure(error))
    );
  };

  function request() {
    return { type: KYCConstants.GET_INSTITUTION_REQUEST };
  }

  function success(data) {
    return { type: KYCConstants.GET_INSTITUTION_SUCCESS, payload: data };
  }

  function failure(error) {
    return { type: KYCConstants.GET_INSTITUTION_ERROR, error };
  }
}

function uploadSignedAgreement(data, documentId) {
  return dispatch => {
    dispatch(request());

    return KYCServices.uploadSignedAgreement(data, documentId).then(
      data => dispatch(success(data)),
      error => {
        dispatch(failure(error));
        throw error;
      }
    );
  };

  function request() {
    return { type: KYCConstants.UPLOAD_SIGNED_AGREEMENT_REQUEST };
  }

  function success(data) {
    return { type: KYCConstants.UPLOAD_SIGNED_AGREEMENT_SUCCESS, payload: data };
  }

  function failure(error) {
    return { type: KYCConstants.UPLOAD_SIGNED_AGREEMENT_ERROR, error };
  }
}

function getCompanyClassification(data) {
  return dispatch => {
    dispatch(request());

    return KYCServices.getCompanyClassification(data).then(
      data => dispatch(success(data)),
      error => {
        dispatch(failure(error));
        throw error;
      }
    );
  };

  function request() {
    return { type: KYCConstants.GET_COMPANY_CLASSIFICATION_REQUEST };
  }

  function success(data) {
    return { type: KYCConstants.GET_COMPANY_CLASSIFICATION_SUCCESS, payload: data };
  }

  function failure(error) {
    return { type: KYCConstants.GET_COMPANY_CLASSIFICATION_ERROR, error };
  }
}

function uploadArticlesOfAssociation(data) {
  return dispatch => {
    dispatch(request());

    return KYCServices.uploadArticlesOfAssociation(data).then(
      data => dispatch(success(data)),
      error => dispatch(failure(error))
    );
  };

  function request() {
    return { type: KYCConstants.UPLOAD_ARTICLES_OF_ASSOCIATION_REQUEST };
  }

  function success(data) {
    return { type: KYCConstants.UPLOAD_ARTICLES_OF_ASSOCIATION_SUCCESS, payload: data };
  }

  function failure(error) {
    return { type: KYCConstants.UPLOAD_ARTICLES_OF_ASSOCIATION_ERROR, error };
  }
}

function uploadBeneficiaryDocuments(data) {
  return dispatch => {
    dispatch(request());

    return KYCServices.uploadBeneficiaryDocuments(data).then(
      data => dispatch(success(data)),
      error => dispatch(failure(error))
    );
  };

  function request() {
    return { type: KYCConstants.UPLOAD_BENEFECIARY_DOCUMENTS_REQUEST };
  }

  function success(data) {
    return { type: KYCConstants.UPLOAD_BENEFECIARY_DOCUMENTS_SUCCESS, payload: data };
  }

  function failure(error) {
    return { type: KYCConstants.UPLOAD_BENEFECIARY_DOCUMENTS_ERROR, error };
  }
}

function uploadWolfsbergQuestionnaire(data) {
  return dispatch => {
    dispatch(request());

    return KYCServices.uploadWolfsbergQuestionnaire(data).then(
      data => dispatch(success(data)),
      error => dispatch(failure(error))
    );
  };

  function request() {
    return { type: KYCConstants.UPLOAD_WOLFSBERG_QUESTIONNAIRE_REQUEST };
  }

  function success(data) {
    return { type: KYCConstants.UPLOAD_WOLFSBERG_QUESTIONNAIRE_SUCCESS, payload: data };
  }

  function failure(error) {
    return { type: KYCConstants.UPLOAD_WOLFSBERG_QUESTIONNAIRE_ERROR, error };
  }
}

function submitApplication(data) {
  return dispatch => {
    dispatch(request());
    return KYCServices.submitApplication(data).then(
      data => dispatch(success(data)),
      error => {
        dispatch(failure(error));
        throw error;
      }
    );
  };

  function request() {
    return { type: KYCConstants.SUBMIT_APPLICATION_REQUEST };
  }

  function success(data) {
    return { type: KYCConstants.SUBMIT_APPLICATION_SUCCESS, payload: data };
  }

  function failure(error) {
    return { type: KYCConstants.SUBMIT_APPLICATION_ERROR, error };
  }
}

function startApplicationSigning(authType) {
  return dispatch => {
    dispatch(request());

    return KYCServices.startApplicationSigning(authType).then(
      data => dispatch(success(data)),
      error => {
        dispatch(failure(error));
        throw error;
      }
    );
  };

  function request() {
    return { type: KYCConstants.START_APPLICATION_SIGNING_REQUEST };
  }

  function success(data) {
    return { type: KYCConstants.START_APPLICATION_SIGNING_SUCCESS, payload: data, authType };
  }

  function failure(error) {
    return { type: KYCConstants.START_APPLICATION_SIGNING_ERROR, error };
  }
}

function startApplicationSignedUpload(data) {
  return dispatch => {
    dispatch(request());

    return KYCServices.startApplicationSignedUpload(data).then(
      data => dispatch(success(data)),
      error => {
        dispatch(failure(error));
        throw error;
      }
    );
  };

  function request() {
    return { type: KYCConstants.START_APPLICATION_SIGNED_UPLOAD_REQUEST };
  }

  function success(data) {
    return { type: KYCConstants.START_APPLICATION_SIGNED_UPLOAD_SUCCESS, payload: data };
  }

  function failure(error) {
    return { type: KYCConstants.START_APPLICATION_SIGNED_UPLOAD_ERROR, error };
  }
}

function checkSigningSca() {
  return dispatch => {
    dispatch(request());

    return KYCServices.checkSigningSca().then(
      data => dispatch(success(data)),
      error => {
        dispatch(failure(error));
        throw error;
      }
    );
  };

  function request() {
    return { type: KYCConstants.CHECK_SIGNING_SCA_REQUEST };
  }

  function success(data) {
    return { type: KYCConstants.CHECK_SIGNING_SCA_SUCCESS, payload: data };
  }

  function failure(error) {
    return { type: KYCConstants.CHECK_SIGNING_SCA_ERROR, error };
  }
}

function cancelSigning() {
  return dispatch => {
    dispatch(request());

    return KYCServices.cancelSigning().then(
      data => dispatch(success(data)),
      error => dispatch(failure(error))
    );
  };

  function request() {
    return { type: KYCConstants.CANCEL_SIGNING_REQUEST };
  }

  function success(data) {
    return { type: KYCConstants.CANCEL_SIGNING_SUCCESS, payload: data };
  }

  function failure(error) {
    return { type: KYCConstants.CANCEL_SIGNING_ERROR, error };
  }
}

function continueApplication() {
  return dispatch => {
    dispatch(request());

    return KYCServices.continueApplication().then(
      data => dispatch(success(data)),
      error => dispatch(failure(error))
    );
  };

  function request() {
    return { type: KYCConstants.CONTINUE_APPLICATION_REQUEST };
  }

  function success(data) {
    return { type: KYCConstants.CONTINUE_APPLICATION_SUCCESS, payload: data };
  }

  function failure(error) {
    return { type: KYCConstants.CONTINUE_APPLICATION_ERROR, error };
  }
}

function checkState() {
  return dispatch => {
    dispatch(request());

    return KYCServices.checkState().then(
      data => dispatch(success(data)),
      error => dispatch(failure(error))
    );
  };

  function request() {
    return { type: KYCConstants.CHECK_STATE_REQUEST };
  }

  function success(data) {
    return { type: KYCConstants.CHECK_STATE_SUCCESS, payload: data };
  }

  function failure(error) {
    return { type: KYCConstants.CHECK_STATE_ERROR, error };
  }
}

function startAgreementSigning(authType) {
  return dispatch => {
    dispatch(request());

    return KYCServices.startAgreementSigning(authType).then(
      data => dispatch(success(data)),
      error => dispatch(failure(error))
    );
  };

  function request() {
    return { type: KYCConstants.START_AGREEMENT_SIGNING_REQUEST };
  }

  function success(data) {
    return { type: KYCConstants.START_AGREEMENT_SIGNING_SUCCESS, payload: data, authType };
  }

  function failure(error) {
    return { type: KYCConstants.START_AGREEMENT_SIGNING_ERROR, error };
  }
}

function uploadAdditionalDocuments(data) {
  return dispatch => {
    dispatch(request());

    return KYCServices.uploadAdditionalDocuments(data).then(
      data => dispatch(success(data)),
      error => dispatch(failure(error))
    );
  };

  function request() {
    return { type: KYCConstants.UPLOAD_ADDITIONAL_DOCUMENTS_REQUEST };
  }

  function success(data) {
    return { type: KYCConstants.UPLOAD_ADDITIONAL_DOCUMENTS_SUCCESS, payload: data };
  }

  function failure(error) {
    return { type: KYCConstants.UPLOAD_ADDITIONAL_DOCUMENTS_ERROR, error };
  }
}

function startOndatoBeneficiaryIdentification() {
  return dispatch => {
    dispatch(request());

    return KYCServices.startOndatoBeneficiaryIdentification().then(
      data => dispatch(success(data)),
      error => dispatch(failure(error))
    );
  };

  function request() {
    return { type: KYCConstants.START_ONDATO_BENEFICIARY_IDENTIFICATION_REQUEST };
  }

  function success(data) {
    return { type: KYCConstants.START_ONDATO_BENEFICIARY_IDENTIFICATION_SUCCESS, payload: data };
  }

  function failure(error) {
    return { type: KYCConstants.START_ONDATO_BENEFICIARY_IDENTIFICATION_ERROR, error };
  }
}

function renderPdfFromHtml(htmlStr) {
  return dispatch => {
    dispatch(request());

    return KYCServices.renderPdfFromHtml(htmlStr).then(
      data => dispatch(success(data)),
      error => dispatch(failure(error))
    );
  };

  function request() {
    return { type: KYCConstants.RENDER_PDF_FROM_HTML_REQUEST };
  }

  function success(data) {
    return { type: KYCConstants.RENDER_PDF_FROM_HTML_SUCCESS, payload: data };
  }

  function failure(error) {
    return { type: KYCConstants.RENDER_PDF_FROM_HTML_ERROR, error };
  }
}

function uploadKycPdf(filesForm) {
  return dispatch => {
    dispatch(request());

    return KYCServices.uploadKycPdf(filesForm).then(
      data => dispatch(success(data)),
      error => dispatch(failure(error))
    );
  };

  function request() {
    return { type: KYCConstants.UPLOAD_KYC_PDF_REQUEST };
  }

  function success(data) {
    return { type: KYCConstants.UPLOAD_KYC_PDF_SUCCESS, payload: data };
  }

  function failure(error) {
    return { type: KYCConstants.UPLOAD_KYC_PDF_ERROR, error };
  }
}
